import type { FC } from "react";

import { cn } from "@/utils/common/styleHelper/utils";

import type SkeletonLengthInterface from "../SkeletonComponent/interfaces/SkeletonLengthInterface";
import Skeleton from "../SkeletonComponent/server/SkeletonComponent";

interface SkeletonTabProps extends SkeletonLengthInterface {
  classNames?: {
    base?: string;
    container?: string;
    text?: {
      outer?: string;
      inner?: string;
    };
    hr?: string;
  };
}

const SkeletonTabComponent: FC<SkeletonTabProps> = ({
  length = 2,
  classNames,
}) => {
  return (
    <div className={cn("flex w-full", classNames?.base)}>
      {Array.from<number>({ length }).map((_, idx) => (
        <div
          key={idx}
          className={cn(
            "md:h-10 h-11 w-full md:w-[120px] relative flex items-center justify-center",
            classNames?.container,
          )}
        >
          <div
            className={cn(
              "flex h-[21px] w-3/4 items-center",
              classNames?.text?.outer,
            )}
          >
            <Skeleton className={cn("h-3.5 w-full", classNames?.text?.inner)} />
          </div>
          <Skeleton
            className={cn(
              "h-px w-full absolute bottom-0 md:block hidden inset-x-0",
              classNames?.hr,
            )}
          />
        </div>
      ))}
    </div>
  );
};

export default SkeletonTabComponent;
